import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useLayoutEffect } from "react";
import { LAYOUT } from "./constants.js";
import { hasMetadataMath, ContentMetadataText } from "../components/common/ContentMetadataText.js";
function TitleQueture({ grade, unitLabel, unitName, quetureTitle, bleedPx = 0 }) {
  const titleRef = useRef(null);
  const naturalRef = useRef(null);
  const unitRowRef = useRef(null);
  const [fit, setFit] = useState({ scale: 1, height: void 0 });
  const hasMath = hasMetadataMath(quetureTitle);
  useLayoutEffect(() => {
    var _a;
    if (!hasMath) return;
    let disposed = false;
    const measure = () => {
      if (disposed) return;
      const title = titleRef.current;
      const natural = naturalRef.current;
      if (!title || !natural || natural.offsetHeight === 0 || title.clientWidth === 0) return;
      const availableHeight = LAYOUT.header.totalHeight + LAYOUT.step1FirstPaddingTop - LAYOUT.title.top - title.offsetTop - 8;
      if (availableHeight <= 0) return;
      const heightScale = availableHeight / natural.offsetHeight;
      const widthScale = title.clientWidth > 0 && natural.scrollWidth > 0 ? title.clientWidth / natural.scrollWidth : 1;
      const scale = Math.min(1, heightScale, widthScale);
      const height = natural.offsetHeight * scale;
      setFit((previous) => previous.scale === scale && previous.height === height ? previous : { scale, height });
    };
    measure();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    if (naturalRef.current) observer == null ? void 0 : observer.observe(naturalRef.current);
    if (unitRowRef.current) observer == null ? void 0 : observer.observe(unitRowRef.current);
    if (titleRef.current) observer == null ? void 0 : observer.observe(titleRef.current);
    const fonts = document.fonts;
    void ((_a = fonts == null ? void 0 : fonts.ready) == null ? void 0 : _a.then(measure, measure));
    fonts == null ? void 0 : fonts.addEventListener("loadingdone", measure);
    return () => {
      disposed = true;
      observer == null ? void 0 : observer.disconnect();
      fonts == null ? void 0 : fonts.removeEventListener("loadingdone", measure);
    };
  }, [hasMath, quetureTitle, grade, unitLabel, unitName, bleedPx]);
  return /* @__PURE__ */ jsxs("div", { className: "absolute", style: { top: LAYOUT.title.top + bleedPx, left: bleedPx, right: bleedPx, zIndex: 1 }, children: [
    /* @__PURE__ */ jsxs("div", { ref: unitRowRef, className: "flex gap-2 items-center", style: { marginLeft: LAYOUT.title.quetureMarginLeft }, children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          className: "shrink-0",
          style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#E6E6E6",
            borderRadius: 100,
            padding: "4px 8px",
            fontSize: 16,
            lineHeight: "normal",
            color: "#808080",
            fontWeight: 600,
            fontFamily: "'Pretendard', sans-serif"
          },
          children: grade
        }
      ),
      /* @__PURE__ */ jsxs("span", { style: { fontSize: 18, color: "#808080", fontWeight: 600, fontFamily: "'Pretendard', sans-serif" }, children: [
        unitLabel,
        "."
      ] }),
      /* @__PURE__ */ jsx("span", { style: { fontSize: 18, color: "#808080", fontWeight: 600, fontFamily: "'Pretendard', sans-serif" }, children: /* @__PURE__ */ jsx(ContentMetadataText, { text: unitName }) })
    ] }),
    /* @__PURE__ */ jsx(
      "p",
      {
        ref: titleRef,
        className: "font-dunggeunmiso",
        style: {
          fontSize: 38,
          color: "#1B2559",
          fontWeight: 700,
          lineHeight: 1.2,
          marginLeft: LAYOUT.title.quetureMarginLeft,
          marginTop: 16,
          letterSpacing: "-0.228px",
          whiteSpace: "pre-line",
          maxWidth: 519,
          ...hasMath ? { height: fit.height } : {}
        },
        children: hasMath ? /* @__PURE__ */ jsx(
          "span",
          {
            ref: naturalRef,
            style: {
              display: "block",
              transform: fit.scale < 1 ? `scale(${fit.scale})` : void 0,
              transformOrigin: "top left"
            },
            children: /* @__PURE__ */ jsx(ContentMetadataText, { text: quetureTitle })
          }
        ) : /* @__PURE__ */ jsx(ContentMetadataText, { text: quetureTitle })
      }
    )
  ] });
}
export {
  TitleQueture
};
//# sourceMappingURL=TitleQueture.js.map
